import consultarVeiculoBaseEstadualSaga from './consultarVeiculoBaseEstadual/saga';
import consultarCadastroBinRenavamSaga from './consultarCadastroBinRenavam/saga';
import consultarBaseOutrosEstadosSaga from './consultarBaseOutrosEstados/saga';
import consultarNumeroMotorBinSaga from './ConsultarNumeroMotorBin/saga';

export const consultarVeiculoBaseEstadual = consultarVeiculoBaseEstadualSaga;
export const consultarCadastroBinRenavam = consultarCadastroBinRenavamSaga;
export const consultarBaseOutrosEstados = consultarBaseOutrosEstadosSaga;
export const consultarNumeroMotorBin = consultarNumeroMotorBinSaga;
